<label class="col-form-label" *ngIf="label">
  {{ label }}
  <span *ngIf="required" aria-hidden="true" class="symbol required text-danger">*</span>
  <span *ngIf="optional && !required" class="text-muted">(Optional)</span>
</label>
<ng-content></ng-content>
<div *ngFor="let key of errorKeys" class="invalid-feedback d-block">
  {{ messageFor(key) }}
</div>
<div *ngIf="serverError" class="text-danger mt-1 err">{{ serverError }}</div>
